"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentStep = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _skeleton = require("../skeleton");
var _BlockedPaymentProviders = require("./BlockedPaymentProviders");
var _DonationBox = require("./DonationBox");
var _PaymentProviderGroup = require("./PaymentProviderGroup");
var _PaymentStepTitle = require("./PaymentStepTitle");
var _jsxRuntime = require("react/jsx-runtime");
// corresponding with the grid style
const OLD_MD_BREAKPOINT = 768;
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  padding: theme.spacing(4, 6),
  width: 'auto',
  maxWidth: 980,
  margin: theme.spacing(4, 'auto'),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.largeComponentRadius,
  [theme.breakpoints.down(OLD_MD_BREAKPOINT)]: {
    borderRadius: 0
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 3)
  }
}));
const PaymentStep = () => {
  const {
    getTestIdProps,
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    setActiveProviderId,
    activeProviderId,
    isPaymentModelLoading,
    paymentModel
  } = (0, _contexts.useCheckoutPayment)();
  const onPaymentActivation = (0, _react.useCallback)(paymentProviderId => {
    if (setActiveProviderId) {
      setActiveProviderId(paymentProviderId);
      void (0, _hooks.updatePaymentProvider)(paymentProviderId);
    }
  }, [setActiveProviderId]);
  const blockedPaymentProvidersCount = paymentModel?.paymentProvidersBlocked.length;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    "data-testid": getTestId(_models.TestId.PaymentSection),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentStepTitle.PaymentStepTitle, {}), isPaymentModelLoading && !paymentModel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_skeleton.PaymentProviderGroupSkeleton, {}) : null, paymentModel?.paymentProviderGroups.map(group => {
      const providerId = group.paymentProviders[0]?.id;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentProviderGroup.PaymentProviderGroup, {
        activeProviderId: activeProviderId ?? 0,
        paymentProviderGroup: group,
        isCardDetailsConsent: Boolean(paymentModel.isCardDetailsConsent),
        onPaymentActivation: onPaymentActivation
      }, providerId);
    }), paymentModel && blockedPaymentProvidersCount != null && blockedPaymentProvidersCount > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_BlockedPaymentProviders.BlockedPaymentProviders, {
      ...getTestIdProps(_models.TestId.BlockedPaymentProviders),
      paymentProviders: paymentModel.paymentProvidersBlocked
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_DonationBox.DonationBox, {})]
  });
};
exports.PaymentStep = PaymentStep;